module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8Zi6Y"))).then(() => parcelRequire('f4eak'));